import React, { useEffect, useState } from 'react';
import { AuthenticationReducer } from 'types/autentication';
import { RootReducerState } from 'types/global';
import { useSelector } from 'react-redux';
import FormInputsGroupTreatment from './GroupNotificationData/formInputsGroupTreatment';
interface GroupNotificationTreatmentsStepsProps {
  currentStepSelected: number;
  tooltipAlert: any;
  setTooltipAlert: React.Dispatch<React.SetStateAction<string>>;
  notificationStatusState: string;
  notificationStatus: any[];
}

const GroupNotificationTreatmentsSteps: React.FC<GroupNotificationTreatmentsStepsProps> = ({
  currentStepSelected,
  tooltipAlert,
  setTooltipAlert,
  notificationStatusState,
  notificationStatus,
}) => {

  const auth: AuthenticationReducer = useSelector((state: RootReducerState) => state.authenticationReducers)
  const [statusIsPendingFinishOrFinished, setStatusIsPendingFinishOrFinished] = useState(false)

  // Estado interno para gerenciar o step atual no tratamento em grupo
  const [internalCurrentStep, setInternalCurrentStep] = useState(currentStepSelected)

  useEffect(() => {
    if (notificationStatusState) {
      const allowedPendingFinishOrFinished = [notificationStatus[4].label,notificationStatus[5].label]
      setStatusIsPendingFinishOrFinished(allowedPendingFinishOrFinished.includes(notificationStatusState))
    }
  }, [notificationStatusState])

  // Sincronizar step interno quando prop externa mudar
  useEffect(() => {
    setInternalCurrentStep(currentStepSelected)
  }, [currentStepSelected])

  const canEditStepOne = true // Será validado internamente no FormInputsGroupTreatment

  return (
    <FormInputsGroupTreatment
      statusIsPendingFinishOrFinished={statusIsPendingFinishOrFinished}
      auth={auth}
      canEditStepOne={canEditStepOne}
      currentStepSelected={internalCurrentStep}
      setCurrentStepSelected={setInternalCurrentStep}
      tooltipAlert={tooltipAlert}
      setTooltipAlert={setTooltipAlert}
    />
  );
};

export default GroupNotificationTreatmentsSteps;
